// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Модалка заказа использует те же классы, что карточка товара; на широком экране
   ProductModal переключает .product-modal__body в row - для заказа оставляем column. */
@media (min-width: 520px) {
  .order-detail-modal__body.product-modal__body {
    flex-direction: column;
  }
}

.order-detail-modal__content {
  max-width: min(640px, 100vw - 32px);
}

.order-detail-modal__body {
  padding-top: 8px;
}

.order-detail-modal__title {
  margin: 0 0 16px 0;
  font-family: 'Neucha', cursive;
  font-size: 1.5rem;
  font-weight: 400;
  color: #4e3f3a;
}

.order-detail-modal__section {
  margin-bottom: 20px;
}

.order-detail-modal__section:last-child {
  margin-bottom: 0;
}

.order-detail-modal__h {
  margin: 0 0 8px 0;
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b5d58;
}

.order-detail-modal__dl {
  display: grid;
  grid-template-columns: minmax(120px, 140px) 1fr;
  gap: 6px 12px;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
}

.order-detail-modal__dl dt {
  margin: 0;
  color: #6b5d58;
}

.order-detail-modal__dl dd {
  margin: 0;
  color: #4e3f3a;
}

.order-detail-modal__mono {
  font-family: ui-monospace, monospace;
  font-size: 0.875rem;
  word-break: break-all;
}

.order-detail-modal__promo {
  margin: 0;
  font-size: 0.9375rem;
  color: #4e3f3a;
}

.order-detail-modal__hint {
  margin: 0;
  font-size: 0.9375rem;
  color: #6b5d58;
}

.order-detail-modal__error {
  margin: 0 0 12px 0;
  font-size: 0.875rem;
  color: #991b1b;
}

.order-detail-modal__table-wrap {
  overflow-x: auto;
  margin: 0 -4px;
}

.order-detail-modal__table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
}

.order-detail-modal__table th,
.order-detail-modal__table td {
  text-align: left;
  padding: 8px 6px;
  border-bottom: 1px solid #e8e4df;
}

.order-detail-modal__table th {
  color: #6b5d58;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .order-detail-modal__content {
    max-width: calc(100vw - 20px);
  }

  .order-detail-modal__title {
    font-size: 1.25rem;
    margin-bottom: 10px;
  }

  .order-detail-modal__section {
    margin-bottom: 14px;
  }

  .order-detail-modal__dl {
    grid-template-columns: 1fr;
    gap: 3px;
    font-size: 0.875rem;
  }

  .order-detail-modal__dl dt {
    font-weight: 600;
  }

  .order-detail-modal__dl dd {
    margin-bottom: 4px;
  }
}

@media (max-width: 430px) {
  .order-detail-modal__body {
    padding-top: 4px;
  }

  .order-detail-modal__h {
    font-size: 0.7rem;
  }

  .order-detail-modal__table {
    font-size: 0.8125rem;
  }

  .order-detail-modal__table th,
  .order-detail-modal__table td {
    padding: 6px 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OrderDetailModal.css"],"names":[],"mappings":"AAAA;uFACuF;AACvF;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,aAAa;EACb,SAAS;EACT,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Модалка заказа использует те же классы, что карточка товара; на широком экране\n   ProductModal переключает .product-modal__body в row - для заказа оставляем column. */\n@media (min-width: 520px) {\n  .order-detail-modal__body.product-modal__body {\n    flex-direction: column;\n  }\n}\n\n.order-detail-modal__content {\n  max-width: min(640px, 100vw - 32px);\n}\n\n.order-detail-modal__body {\n  padding-top: 8px;\n}\n\n.order-detail-modal__title {\n  margin: 0 0 16px 0;\n  font-family: 'Neucha', cursive;\n  font-size: 1.5rem;\n  font-weight: 400;\n  color: #4e3f3a;\n}\n\n.order-detail-modal__section {\n  margin-bottom: 20px;\n}\n\n.order-detail-modal__section:last-child {\n  margin-bottom: 0;\n}\n\n.order-detail-modal__h {\n  margin: 0 0 8px 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #6b5d58;\n}\n\n.order-detail-modal__dl {\n  display: grid;\n  grid-template-columns: minmax(120px, 140px) 1fr;\n  gap: 6px 12px;\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n}\n\n.order-detail-modal__dl dt {\n  margin: 0;\n  color: #6b5d58;\n}\n\n.order-detail-modal__dl dd {\n  margin: 0;\n  color: #4e3f3a;\n}\n\n.order-detail-modal__mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.875rem;\n  word-break: break-all;\n}\n\n.order-detail-modal__promo {\n  margin: 0;\n  font-size: 0.9375rem;\n  color: #4e3f3a;\n}\n\n.order-detail-modal__hint {\n  margin: 0;\n  font-size: 0.9375rem;\n  color: #6b5d58;\n}\n\n.order-detail-modal__error {\n  margin: 0 0 12px 0;\n  font-size: 0.875rem;\n  color: #991b1b;\n}\n\n.order-detail-modal__table-wrap {\n  overflow-x: auto;\n  margin: 0 -4px;\n}\n\n.order-detail-modal__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.875rem;\n}\n\n.order-detail-modal__table th,\n.order-detail-modal__table td {\n  text-align: left;\n  padding: 8px 6px;\n  border-bottom: 1px solid #e8e4df;\n}\n\n.order-detail-modal__table th {\n  color: #6b5d58;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .order-detail-modal__content {\n    max-width: calc(100vw - 20px);\n  }\n\n  .order-detail-modal__title {\n    font-size: 1.25rem;\n    margin-bottom: 10px;\n  }\n\n  .order-detail-modal__section {\n    margin-bottom: 14px;\n  }\n\n  .order-detail-modal__dl {\n    grid-template-columns: 1fr;\n    gap: 3px;\n    font-size: 0.875rem;\n  }\n\n  .order-detail-modal__dl dt {\n    font-weight: 600;\n  }\n\n  .order-detail-modal__dl dd {\n    margin-bottom: 4px;\n  }\n}\n\n@media (max-width: 430px) {\n  .order-detail-modal__body {\n    padding-top: 4px;\n  }\n\n  .order-detail-modal__h {\n    font-size: 0.7rem;\n  }\n\n  .order-detail-modal__table {\n    font-size: 0.8125rem;\n  }\n\n  .order-detail-modal__table th,\n  .order-detail-modal__table td {\n    padding: 6px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
